import { Grid, InputAdornment, Paper, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import '../../../assets/styles/searchKFC.css';
import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from '../../../hooks/useDebounce';
import { useSearcherStore } from '../../../hooks/useSearcherStore';

export const SearchComponent: React.FC<any> = (props): JSX.Element | any => {
    const { showSearcher, setShowSearcher, getFilterProducts } = props;
    const { filterProducts, setFilterProducts } = useSearcherStore();
    const [loading, setLoading] = useState<boolean>(false);
    
    const debouncedSearch = useDebounce(filterProducts.search, 500);

    useEffect(() => {
        onFilter();
    }, [debouncedSearch]);

    const onFilter = async () => {
        setLoading(true);
        await getFilterProducts();
        setLoading(false);
    };

    return (
        <Paper elevation={5} className='paper-search-table'>
            <Grid className='main-container'>
                <TextField
                    variant="outlined"
                    placeholder={'Buscador'}
                    size='small'
                    fullWidth
                    value={filterProducts.search}
                    onChange={(e) => setFilterProducts({ ...filterProducts, search: e.target.value })}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                        sx: {borderColor: '#4A90E2', // Aplica el color del borde directamente
                            '&.MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: '#4A90E2', // Color del borde en estado normal
                              },
                              '&:hover fieldset': {
                                borderColor: '#4A90E2', // Color del borde cuando pasas el mouse
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#4A90E2', // Color del borde cuando el campo está enfocado
                              },
                            }}
                    }}
                    sx={{ width: 350 }}
                />
            </Grid>
        </Paper>
    );
};
